export const Shape1 = (): JSX.Element => {
  return (
    <div className="absolute w-full h-full">
      <div
        className="absolute w-full h-full"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/images/product/bg/img_karaoke_dt_top_1.png) 1.812rem 5.562rem no-repeat`,
          backgroundSize: '212px 250px',
        }}
      ></div>
      <div
        className="absolute w-full h-full"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/images/product/bg/img_karaoke_dt_top_2.png) 100% 0 no-repeat`,
          backgroundSize: '148px 250px',
        }}
      ></div>
    </div>
  );
};

export const Shape2 = (): JSX.Element => {
  return (
    <div className="absolute w-full h-full">
      <div
        className="absolute w-full h-full"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/images/product/bg/img_karaoke_dt_bottom_1.png) 0 100% no-repeat`,
          backgroundSize: '212px 360px',
        }}
      ></div>
      <div
        className="absolute w-full h-full"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/images/product/bg/img_karaoke_dt_bottom_2.png) 100% 100% no-repeat`,
          backgroundSize: '148px 360px',
        }}
      ></div>
    </div>
  );
};

export const Shape3 = (): JSX.Element => {
  return (
    <div className="absolute w-full h-full">
      <div
        className="absolute w-full h-full"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/images/product/bg/img_bixby_dt_top_1.png) 0 0 no-repeat`,
          backgroundSize: '148px 250px',
        }}
      ></div>
      <div
        className="absolute w-full h-full"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/images/product/bg/img_bixby_dt_top_2.png) 100% 0 no-repeat`,
          backgroundSize: '212px 250px',
        }}
      ></div>
    </div>
  );
};

export const Shape4 = (): JSX.Element => {
  return (
    <div className="absolute w-full h-full">
      <div
        className="absolute w-full h-full"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/images/product/bg/img_bixby_dt_bottom_1.png) 0 100% no-repeat`,
          backgroundSize: '148px 360px',
        }}
      ></div>
      <div
        className="absolute w-full h-full"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/images/product/bg/img_bixby_dt_bottom_2.png) 100% 100% no-repeat`,
          backgroundSize: '212px 360px',
        }}
      ></div>
    </div>
  );
};
